import TemplateView from '../../../../TemplateView'
import {ReportType} from '../../../constants'
import {isReportAvailable} from '../utils'

export default class ChooseReportSection extends TemplateView {
    constructor({
        reportNameKeys = {},
        tabSelected = () => {},
    }) {
        super()

        this.params = {
            reportNameKeys,
            tabSelected,
        }

        this.state = {
            selectedType: null,
            userRights: {},
            features: {},
        }

        this.timeReports = [
            ReportType.STAFF_PERFORMANCE,
            ReportType.OVERTIME,
            ReportType.LEAVE_TIME,
            ReportType.TIME_TRACK_IN_DETAIL,
            ReportType.ESTIMATED_VS_ACTUAL,
        ]

        this.billingReports = [
            ReportType.BILLING_SUMMARY,
            ReportType.INVOICING,
            ReportType.COST_OF_WORK,
            ReportType.PROFIT_LOSS,
        ]

        this.onStatePropertyChanged('selectedType', (selectedType) => {
            Object.keys(this.$buttons).map((type) => {
                this.$buttons[type].toggleClass('pressed', selectedType === type)
            })
        })

        this.onStatePropertyChanged('userRights', () => {
            this.$buttons[ReportType.STAFF_PERFORMANCE].toggle(this._isTabShown(ReportType.STAFF_PERFORMANCE))
            this.$buttons[ReportType.OVERTIME].toggle(this._isTabShown(ReportType.OVERTIME))
            this.$buttons[ReportType.LEAVE_TIME].toggle(this._isTabShown(ReportType.LEAVE_TIME))
            this.$buttons[ReportType.TIME_TRACK_IN_DETAIL].toggle(this._isTabShown(ReportType.TIME_TRACK_IN_DETAIL))
            this.$buttons[ReportType.ESTIMATED_VS_ACTUAL].toggle(this._isTabShown(ReportType.ESTIMATED_VS_ACTUAL))
            this.$buttons[ReportType.BILLING_SUMMARY].toggle(this._isTabShown(ReportType.BILLING_SUMMARY))
            this.$buttons[ReportType.INVOICING].toggle(this._isTabShown(ReportType.INVOICING))
            this.$buttons[ReportType.COST_OF_WORK].toggle(this._isTabShown(ReportType.COST_OF_WORK))
            this.$buttons[ReportType.PROFIT_LOSS].toggle(this._isTabShown(ReportType.PROFIT_LOSS))

            const showTimeReports = this.timeReports.map((type) => this._isTabShown(type)).reduce((acc, value) => acc || value, false)
            this.find('.timeReports').toggle(showTimeReports)

            const showBillingReports = this.billingReports.map((type) => this._isTabShown(type)).reduce((acc, value) => acc || value, false)
            this.find('.billingReports').toggle(showBillingReports)
        })
    }

    templateHtml() {
        return '<div class="indexContent">' +
               '  <div class="timeReports">' +
               '    <div class="indexHeader"><%-firstCategoryHeader%></div>' +
               '    <div class="staffButton reportButton"><%-staff%></div>' +
               '    <div class="overtimeButton reportButton"><%-overtime%></div>' +
               '    <div class="balancesButton reportButton"><%-balance%></div>' +
               '    <div class="timeTrackButton reportButton"><%-timetrack%></div>' +
               '    <div class="evaButton reportButton"><%-eva%></div>' +
               '  </div>' +
               '  <div class="billingReports">' +
               '    <div class="indexHeader"><%-secondCategoryHeader%></div>' +
               '    <div class="billingButton reportButton"><%-billing%></div>' +
               '    <div class="invoiceButton reportButton"><%-invoice%></div>' +
               '    <div class="costOfWorkButton reportButton"><%-cost%></div>' +
               '    <div class="profitLossButton reportButton"><%-profit_loss%></div>' +
               '  </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            firstCategoryHeader: 'saved_reports.category.time',
            secondCategoryHeader: 'saved_reports.category.money',

            staff: this.params.reportNameKeys[ReportType.STAFF_PERFORMANCE],
            overtime: this.params.reportNameKeys[ReportType.OVERTIME],
            balance: this.params.reportNameKeys[ReportType.LEAVE_TIME],
            timetrack: this.params.reportNameKeys[ReportType.TIME_TRACK_IN_DETAIL],
            eva: this.params.reportNameKeys[ReportType.ESTIMATED_VS_ACTUAL],
            billing: this.params.reportNameKeys[ReportType.BILLING_SUMMARY],
            invoice: this.params.reportNameKeys[ReportType.INVOICING],
            cost: this.params.reportNameKeys[ReportType.COST_OF_WORK],
            profit_loss: this.params.reportNameKeys[ReportType.PROFIT_LOSS],

        }
    }

    afterRender() {
        this.$buttons = {}
        this.$buttons[ReportType.STAFF_PERFORMANCE] = this.find('.staffButton')
        this.$buttons[ReportType.OVERTIME] = this.find('.overtimeButton')
        this.$buttons[ReportType.LEAVE_TIME] = this.find('.balancesButton')
        this.$buttons[ReportType.TIME_TRACK_IN_DETAIL] = this.find('.timeTrackButton')
        this.$buttons[ReportType.ESTIMATED_VS_ACTUAL] = this.find('.evaButton')
        this.$buttons[ReportType.BILLING_SUMMARY] = this.find('.billingButton')
        this.$buttons[ReportType.INVOICING] = this.find('.invoiceButton')
        this.$buttons[ReportType.COST_OF_WORK] = this.find('.costOfWorkButton')
        this.$buttons[ReportType.PROFIT_LOSS] = this.find('.profitLossButton')

        Object.keys(this.$buttons).map((type) => {
            this.$buttons[type].click(() => this.params.tabSelected(type))
        })
    }

    _isTabShown(type) {
        return isReportAvailable(type, this.state.userRights, this.state.features)
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ChooseReportSection.js